import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpHeader from "../../common/SetUpHeader"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Pump = (props: Props) => {
  return (
    <SetUpLayout
      title='Pump'

      header={
        <SetUpHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }} />}
    >
      <LayoutMain title="Data 3 of 9" subtitle="Pumps" />
    </SetUpLayout>
  )
}

export default Pump